const SET_RECOMMENDATIONS = 'recommendations//SET_RECOMMENDATIONS'
const ADD_RECOMMENDATION = 'recommendations//ADD_RECOMMENDATION'
const REMOVE_RECOMMENDATIONS = 'recommendations//REMOVE_RECOMMENDATIONS'
const EDIT_RECOMMENDATION = 'recommendations//EDIT_RECOMMENDATION'

export {
  SET_RECOMMENDATIONS,
  ADD_RECOMMENDATION,
  EDIT_RECOMMENDATION,
  REMOVE_RECOMMENDATIONS
}
